import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const TopLensesContainer = styled.div`
    display: flex;
    align-items: center;

    width: 1080px;
    height: 440px;
    margin-bottom: 60px;
    padding: 0 24px;

    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 14%);

    /* stylelint-disable-next-line selector-class-pattern -- Class Name is defined by AntD */
    > .top-lens-card_container:not(:last-child) {
        margin-right: 16px;
    }
`;

export const headerSectionContainerStyle = css`
    align-items: flex-start;
    justify-content: space-between;

    > .sds-base-button.ant-btn.default {
        min-width: 200px;
    }
`;
